var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PointRuleList'
      }
    }
  }, [_vm._v("入點比例管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PointRuleList'
      }
    }
  }, [_vm._v("入點比例列表")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isEditing ? "編輯入點比例" : "新增入點比例") + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEditing ? "編輯入點比例" : "新增入點比例") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路 id"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants
    },
    model: {
      value: _vm.merchantId,
      callback: function callback($$v) {
        _vm.merchantId = $$v;
      },
      expression: "merchantId"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "比對值"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.pointRule.key,
      callback: function callback($$v) {
        _vm.$set(_vm.pointRule, "key", $$v);
      },
      expression: "pointRule.key"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "點數/倍數"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.pointRule.value,
      callback: function callback($$v) {
        _vm.$set(_vm.pointRule, "value", $$v);
      },
      expression: "pointRule.value"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "比對值類型"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.pointRule.type,
      callback: function callback($$v) {
        _vm.$set(_vm.pointRule, "type", $$v);
      },
      expression: "pointRule.type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動代碼"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.pointRule.event_id,
      callback: function callback($$v) {
        _vm.$set(_vm.pointRule, "event_id", $$v);
      },
      expression: "pointRule.event_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.pointRule.order,
      callback: function callback($$v) {
        _vm.$set(_vm.pointRule, "order", $$v);
      },
      expression: "pointRule.order"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分類"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    model: {
      value: _vm.pointRule.cate,
      callback: function callback($$v) {
        _vm.$set(_vm.pointRule, "cate", $$v);
      },
      expression: "pointRule.cate"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goToList
    }
  }, [_vm._v("返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存 ")])], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }